<template>
  <TableEmpty v-if="!loading && users.length === 0" style="top: 50%" />
  <PageScroll
    v-else
    class="-width-limiter-"
    :data="users"
    :is-loading="loading || noMorePage"
    width="100%"
    @incrementPage="incrementPage"
  >
    <Table :nav-titles="navTitles">
      <template #nav>
        <NavCell
          v-for="title in navTitles"
          :key="title.id"
          :class="{ '-pointer-': title.reversed !== undefined }"
          @click.native="setSort(title)"
        >
          <span>{{ title.title }}</span>
          <Icon
            v-if="title.reversed !== undefined"
            class="ui-space-table__icon -arrow-"
            icon="ui-down"
            :class="{
              '-active-': title.order === sortChanel,
              '-rotate-': title.reversed
            }"
          />
        </NavCell>
      </template>
      <template v-if="loading && !loadMore">
        <Row
          v-for="i in 5"
          :key="`load-${i}`"
          :loading="true"
          :nav-titles="navTitles"
          load-cell-class="-full-border-"
          height="43px"
        />
      </template>
      <template v-else>
        <Row
          v-for="user in users"
          :key="user.id"
          class="-pointer-"
          :nav-titles="navTitles"
          height="43px"
          @click="goTo(user)"
        >
          <Cell class="-full-border-">
            {{ user.name }}
            {{ user.patronymic || '' }}
            {{ user.lastname }}
          </Cell>
          <Cell class="-full-border-">
            {{ user.niche }}
          </Cell>
          <Cell class="-full-border-">
            {{ getUserChanel(user, 'revenue') | numberFormat }}
          </Cell>
          <Cell class="-full-border-">
            {{ getUserChanel(user, 'profit') | numberFormat }}
          </Cell>
        </Row>
      </template>
      <Row
        v-if="loadMore"
        :key="`load-more`"
        :loading="true"
        :nav-titles="navTitles"
        load-cell-class="-full-border-"
        height="43px"
      />
    </Table>
  </PageScroll>
</template>

<script>
import { mapState } from 'vuex';
import Table from '../../../components/Table';
import Row from '../../../components/Table/Row';
import Cell from '../../../components/Table/Cell';
import NavCell from '../../../components/Table/NavCell';

export default {
  components: {
    Table,
    Row,
    Cell,
    NavCell
  },
  props: {
    sortChanel: {},
    navTitles: {}
  },
  data: () => ({
    loadMore: false
  }),
  computed: {
    ...mapState('ratingUnifiedGlobal', {
      users: s => s.data.users,
      page: s => s.data.page,
      isLoading: s => s.meta.isLoading,
      isLoadingPage: s => s.meta.isLoadingPage,
      noMorePage: s => s.meta.noMorePage
    }),
    isAdmin() {
      return this.$store.state['auth'].data.user.permissions.isAdmin;
    },
    loading() {
      return this.isLoading || this.isLoadingPage;
    }
  },
  methods: {
    goTo(user) {
      if (!this.isAdmin) {
        return;
      }
      this.$router.push(`/rating/unified/user/${user.id}`);
    },
    async incrementPage() {
      this.loadMore = true;
      this.$store.dispatch('ratingUnifiedGlobal/setData', {
        path: 'page',
        value: this.page + 1
      });
      await this.$store.dispatch('ratingUnifiedGlobal/getUserList');
      this.loadMore = false;
    },
    getUserChanel(user, id) {
      const channel = user.info.find(({ channelId }) => channelId === id);
      return channel ? channel.fullProfit : 0;
    },
    setSort(title) {
      if (title.channel === undefined && title.reversed === undefined) {
        return;
      }
      this.$emit('setSort', title);
    }
  }
};
</script>
